<template>
    <c-app-content
        :hide-top    = "true"
        @initialized = "onInitialized"
    >
        <template v-slot:content>
            <d-site
                v-model  = "unit.show"
                :site-id = "unit.id"
            />

            <div
                id    = "site-search-panel"
                class = "overview-panel v-flex"
                :key  = "count"
            >
                <m-site-overview-menu
                    @download = "onDownload"
                    @refresh  = "onRefresh"
                />
                <div>
                    <table id="site-table" class="table table-hover table-bordered">
                        <thead>
                        <tr class="table-header">
                            <th class="text-center">
                                <v-table-header-cell
                                    group   ="msd.overview.header"
                                    first   = "lgsmart"
                                    second  = "dms"
                                    v-model = "sort"
                                />
                            </th>

                            <th class="text-center">
                                <v-table-header-cell
                                    group   ="msd.overview.header"
                                    first   = "fabricNo"
                                    second  ="id"
                                    v-model = "sort"
                                />
                            </th>
                            <th class="text-center">
                                <v-table-header-cell
                                    group   ="msd.overview.header"
                                    first   = "customer"
                                    second  ="group"
                                    :sortable="{ first: true, second: false }"
                                    v-model = "sort"
                                />
                            </th>
                            <th class="text-center">
                                <v-table-header-cell
                                    group   ="msd.overview.header"
                                    first   = "ve"
                                    second  ="ve2"
                                    v-model = "sort"
                                />
                            </th>
                            <th class="text-center">
                                <v-table-header-cell
                                    group   ="msd.overview.header"
                                    first   = "ve3"
                                    second  ="branch"
                                    v-model = "sort"
                                />
                            </th>
                            <th class="text-center">
                                <v-table-header-cell
                                    group   ="msd.overview.header"
                                    first   = "street"
                                    second  ="city"
                                    v-model = "sort"
                                />
                            </th>

                            <th class="text-center" style="padding-bottom: 10px!important;">Hersteller<br>BJ Tragkr. HS  ZS</th>
                            <th class="text-center">Geschw.</th>
                            <th class="text-center">Aufzugsart<br>Antriebsart</th>
                            <th class="text-center">Status<br>LM</th>
                            <th class="text-center">Wartungsnehmer<br>Wartungsart</th>
                            <th class="text-center">Aktuell?<br>Endet am</th>
                            <th class="text-center">Notrufnehmer<br>Notrufart</th>
                            <th class="text-center" style="border-right: 0">Aktuell?<br>Endet am</th>
                            <th class="text-center" style="border-right: 0"></th>
                        </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </template>
    </c-app-content>
</template>

<script>

import $ from 'jquery';
import 'datatables.net';
import moment            from 'moment'
import tables            from '@/assets/js/tables'
import security          from '@/main'
import SearchRequest from "@/modules/core/service/private/SearchRequest";
import Core              from "@/modules/core/service/Core";
import MSiteOverviewMenu from "@/modules/msd/unit/components/main/MSiteOverviewMenu";
import VTableHeaderCell  from "@/modules/core/components/utils/VTableHeaderCell";
import Contract          from "@/modules/msd/company/contract/service/Contract";
import CAppContent       from "@/modules/core/components/app/CAppContent";
import Site from "@/modules/msd/unit/service/Site";
import Customer from "@/modules/msd/company/customer/service/Customer";
import DSite from "@/modules/msd/unit/components/dialog/DSite.vue";


const Const = {
    nl   : '<br>',
    na   : '-/-',
    table: {
        id         : '#site-table',
        url        : '/site',
        checkicon  : tables.css.icon.check,
        uncheckicon: tables.css.icon.uncheck,
    },
    format: {
        date: 'DD.MM.yyyy'
    }
};

const editButton = function (symbol) {
    if (!symbol) {
        return null;
    }

    return '<a><i style="font-size: 22px; width: 22px; height: 100%;" class="v-icon mdi primary--text unit-edit ' + symbol + '" /></a>'
}

export default {
    name: "MSiteOverview",

    components: {
        DSite,
        CAppContent,
        VTableHeaderCell,
        MSiteOverviewMenu
    },

    data: () => ({
        count: 0,
        filter : {
        },

        state: [
            "status-r",
            "status-y",
            "status-g"
        ],
        sort : {
            column: "fabricNo",
            dir   : "DESC"
        },

        unit: {
            show: false,
            id  : null
        }
    }),

    watch: {
        sort: {
            handler: function () {
                this.onRefresh();
            },
            deep: true
        }
    },

    computed: {
        preferences() {
            return this.$store.getters.preferences;
        },

        columns () {
            const self = this;
            return [
                {
                    width: '33px',
                    class: 'text-center table-no-frame',
                    render: function (data, type, row) {
                        return self.status (row);
                    }
                },
                {
                    width: '160px',
                    class: "pl-1 pr-0",
                    render: function (data, type, row) {
                        return tables.cell(row.fabricNo, row.id);
                    }
                },
                {
                    width: '10%',
                    render: function (data, type, row) {
                        const customerGroup = self.customerGroup (row.customer);
                        return tables.cell(row.customer.name, customerGroup);
                    }
                },
                {
                    width: '8%',
                    render: function (data, type, row) {
                        return tables.cell(row.ve, row.ve2);
                    }
                },
                {
                    width: '8%',
                    render: function (data, type, row) {
                        return tables.cell(row.ve3, row.branch);
                    }
                },
                {
                    width: '16%',
                    render(data, type, row) {
                        return tables.cell(row.street, row.zip + ' ' + row.city);
                    }
                },
                {
                    width: '10%',
                    class: 'hc-info-table',
                    render(data, type, row) {
                        const specification = row.specification;
                        return '<table>'
                            + '<tr>'
                            + '<td colspan="4">' + tables.line(specification.manufacturer ? specification.manufacturer.name : '') + '</td>'
                            + '</tr>'
                            + '<tr>'
                            + '<td>' + tables.empty(specification.yearOfConstruction) + '</td>'
                            + '<td>' + tables.empty(specification.loadCapacityKg) + '</td>'
                            + '<td>' + tables.empty(specification.stops) + '</td>'
                            + '<td>' + tables.empty(specification.entrypoints) + '</td>'
                            + '</tr>'
                            + '</table>'
                            ;
                    }
                },
                {
                    width: '3%',
                    class: 'text-center',
                    render(data, type, row) {
                        return tables.floatAsString(row.specification.speed);
                    }
                },
                {
                    width: '10%',
                    render(data, type, row) {
                        return tables.cell(row.type.name,row.specification.typeOfDrive ? row.specification.typeOfDrive.name : '');
                    }
                },
                {
                    width: '50px',
                    class: 'text-center',
                    render(data, type, row) {
                        const siteStatus = self.siteStatus (row);
                        const limStatus  = self.limStatus (row);
                        return tables.cell(siteStatus, limStatus);
                    }
                },
                {
                    width: '10%',
                    render(data, type, row) {
                        if (!row.liftmanagement)
                            return "";

                        const contract = row.liftmanagement.mntContract;
                        if (!contract)
                            return "";

                        return tables.cell(contract.company ? contract.company.name : '', contract.contracttype ? contract.contracttype.name: '');
                    }
                },
                {
                    class: 'text-center',
                    width: '90px',
                    render(data, type, row) {
                        if (!row.liftmanagement)
                            return "";

                        const contract = row.liftmanagement.mntContract;
                        if (!contract)
                            return "";

                        return (contract.active ? Const.table.checkicon : Const.table.uncheckicon)
                            + Const.nl
                            + (contract.expiration ? moment(contract.expiration).format(Const.format.date) : Const.na)
                            ;
                    }
                },
                {
                    width: '8%',
                    render(data, type, row) {
                        if (!row.liftmanagement || !row.liftmanagement.escContract)
                            return "";

                        const contract = row.liftmanagement.escContract;
                        if (!contract)
                            return "";

                        return tables.cell(contract.company ? contract.company.name : null, contract.type ? contract.type.name : null);
                    }
                },
                {
                    class: tables.css.cell.center,
                    width: '90px',
                    render(data, type, row) {
                        if (!row.liftmanagement || !row.liftmanagement.escContract)
                            return "";

                        const contract = row.liftmanagement.escContract;
                        if (!contract)
                            return "";

                        return (contract.active ? Const.table.checkicon : Const.table.uncheckicon)
                            + Const.nl
                            + (contract.expiration ? moment(contract.expiration).format(Const.format.date) : Const.na)
                            ;
                    }
                },
                {
                    class: 'text-center table-no-frame',
                    width: "20px",
                    render(data, type, row) {
                        return editButton(row ? row.type.symbol : null)
                    }
                },
            ]
        },
    },

    created() {
        this.$bus.$on(this.$events.refresh, this.onRefresh);
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.refresh, this.onRefresh);
    },

    methods: {
        onInitialized () {
            this.filter = this.$route.params;
            this.count ++;
            this.$nextTick(() => {
                this.onRefresh();
            })
        },

        onDownload () {
            $(Const.table.id).DataTable().button('.buttons-csv').trigger();
        },

        onRefresh (filter) {
            if (filter) {
                this.filter = filter;
            }

            this.show(this.filter);
        },

        show(filter) {
            const self = this;

            $.fn.DataTable.ext.pager.numbers_length = 10;
            const table = $(Const.table.id).dataTable({
                dom: 'Bfrtip',
                buttons: [
                    'csv',
                    'print'
                ],
                processing  : false,
                serverSide  : true,
                paging      : true,
                searching   : false,
                ordering    : false,
                info        : true,
                autoWidth   : false,
                lengthChange: false,
                deferRender : true,
                destroy     : true,
                idSrc       : 'id',
                rowId       : 'id',
                select      : true,
                language    : tables.language(),
                infoCallback: function (settings, start, end, max, total) {
                    if (total === 0) return '';
                    return self.$t('site.pagination.info', [ start, end, total ]);
                },
                ajax        : {
                    headers : security.jsonHeader(),
                    dataType: 'json',
                    type    : 'POST',
                    url     : SearchRequest.url(Const.table.url),
                    data: function ( d ) {
                        return JSON.stringify(SearchRequest.table(d, self.sort, SearchRequest.siteFilter(filter)));
                    },
                    dataSrc: 'data',
                    beforeSend: function () {
                        Core.loading(self, true);
                    },
                    complete: function () {
                        Core.loading(self, false);
                    },
                    error: function (xhr)
                    {
                        if (xhr.status === 401) {
                            security.logout();
                        }
                    }
                },
                drawCallback: function() {
                    $(Const.table.id).find('td').each (function () {
                        const text = $(this).text();
                        this.setAttribute( 'title', text);
                    });
                },
                columns: this.columns
            });

            table.on( 'click', 'tr', function (e) {
                const rowdata = table.api().row( $(this)).data();

                if (rowdata) {
                    if (e.target && e.target.className.includes("unit-edit")) {
                        self.unit.show = true;
                        self.unit.id = rowdata.id;
                        e.stopPropagation();
                        return;
                    }

                    Site.goto(self, rowdata.id);
                }
            });
        },

        siteStatus (site) {
            if (!site.status) {
                return "";
            }

            if (site.status.id !== 1) {
                return site.status.name;
            }

            const xxx = this.limStatus(site);
            return site.status && xxx.length > 0 ? site.status.name : '';
        },

        limStatus (site) {
            const liftmanagement = site.liftmanagement;
            let limStatus  = "";

            if (liftmanagement && liftmanagement.contract) {
                const contract = liftmanagement.contract;
                if (contract.active) {
                    if (contract.type.id === Contract.enums.types.lim) {
                        limStatus = "LIM";
                    }

                    if (contract.type.id === Contract.enums.types.dls) {
                        limStatus = "DLS";
                    }
                }
            }

            return limStatus;
        },

        customerGroup (customer) {
            if (!customer.statistics) {
                return "";
            }

            let result = "";
            const lim = Customer.contractStatistic(customer, Contract.enums.types.lim);
            const dls = Customer.contractStatistic(customer, Contract.enums.types.dls);

            if (lim && lim.active > 0) {
                result = result + "LIM";
            }

            if (dls && dls.active > 0) {
                if (lim && lim.active > 0) {
                    result += " / "
                }
                result = result + "DLS";
            }

            return result;
        },

        status (row) {
            let color = "";
            const liftmanagement = row.liftmanagement;
            if (liftmanagement && liftmanagement.contract) {
                const contract = liftmanagement.contract;
                if (contract.active) {
                    const statistic = row.statistic;
                    color = this.state[statistic.state];
                }
            }

            const textColor = color.length === 0 ? 'black--text' : 'white--text';
            if (color.length === 0) {
                color = "status-w";
            }
            let result = "<div class='" + color + "'>";
            if (row.deviceLGSmart) {
                result += "<i class='v-icon mdi mdi-router-wireless " + textColor + "' style='font-size: 22px'></i>"
            } else {
                result += "<i class='v-icon mdi mdi-router-wireless-off " + textColor + "' style='font-size: 22px'></i>"
            }

            if (row.dmsId) {
                result += "<i class='v-icon mdi mdi-link " + textColor + "' style='font-size: 22px'></i>"
            } else {
                result += "<i class='v-icon mdi mdi-link-off " + textColor + "' style='font-size: 22px'></i>"
            }

            return result + "</div>";
        }
    }
}
</script>

<style scoped>

::v-deep .dt-buttons {
    display: none;
}

</style>